import React from 'react';

const UserLayout = ({children}) => {
    return (
        <div>
            {children}
        </div>
    );
};

export default UserLayout;